"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityCollectionBase = void 0;
const ErrorHandlingHelper_1 = require("./ErrorHandlingHelper");
class EntityCollectionBase extends ErrorHandlingHelper_1.ErrorHandlingHelper {
    constructor() {
        super(...arguments);
        this.objectsPerPage = 25;
        this.pageNumber = 1;
        this.totalObjectCount = 0;
        this.totalPageCount = 1;
        this._dtos = [];
        this._items = [];
        this._eventListeners = {};
        this._state = "ready";
    }
    get state() {
        return this._state;
    }
    off(eventName, listener) {
        if (eventName === undefined) {
            this._eventListeners = {};
        }
        else if (this._eventListeners[eventName]) {
            if (listener === undefined) {
                delete this._eventListeners[eventName];
                return;
            }
            for (let i = 0, l = this._eventListeners[eventName].length; i < l; i++) {
                if (this._eventListeners[eventName][i] === listener) {
                    this._eventListeners[eventName].splice(i, 1);
                    break;
                }
            }
        }
    }
    on(eventName, listener) {
        if (!this._eventListeners[eventName]) {
            this._eventListeners[eventName] = [];
        }
        else {
            const l = this._eventListeners[eventName].length;
            for (let i = 0; i < l; i++) {
                if (this._eventListeners[eventName][i] === listener) {
                    return;
                }
            }
        }
        this._eventListeners[eventName].push(listener);
    }
    _emit(eventName, obj) {
        if (this._eventListeners[eventName]) {
            this._eventListeners[eventName].forEach((listener) => { listener(obj); });
        }
    }
    _hasEventListeners(eventName) {
        return eventName !== undefined ?
            !!this._eventListeners[eventName] :
            Object.keys(this._eventListeners).length > 0;
    }
    _setState(state) {
        if (this._state != state) {
            this._state = state;
            this._emit("state-change", this._state);
        }
    }
}
exports.EntityCollectionBase = EntityCollectionBase;
//# sourceMappingURL=EntityCollectionBase.js.map